import { SmartComponentNewPropertyDetailsSave } from "./smart-component-new-property-details-save";

export class SmartComponentNewPropertySave {
  public idSmartComponentKind: number = 0;
  public idArea: number = 0;
  public skills: SmartComponentNewPropertyDetailsSave[] = [];

  constructor(controlType?: any) {
    // used for assign type to instance of object
    if (controlType) {
      Object.assign(this, controlType);
    }
  }
}
